import { inject, Injectable } from '@angular/core';
import type { MixPanelEventsKeys } from '../constants/mix-panel.constant';
import { MIX_PANEL } from '../constants/mix-panel.constant';
import type { Dict } from 'mixpanel-browser';
import mixpanel from 'mixpanel-browser';
import { APP_CONFIG } from '@shared/tokens/global';

@Injectable({
  providedIn: 'root',
})
export class MixPanelService {
  private appConfig = inject(APP_CONFIG);

  init() {
    MIX_PANEL.metaBoxTrack = mixpanel.init(
      this.appConfig.mixpanelToken,
      {
        ignore_dnt: true,
      },
      'metaBoxTrack',
    );
    MIX_PANEL.streamTrack = mixpanel.init(
      this.appConfig.mixpanelStreamToken,
      {
        ignore_dnt: true,
      },
      'streamTrack',
    );
    this.trackMetabox('Metabox started');
    this.trackStream('Metabox started');
  }

  trackMetabox(event: MixPanelEventsKeys | string, data?: Dict) {
    MIX_PANEL.metaBoxTrack?.track(event, data);
  }

  trackStream(event: MixPanelEventsKeys | string, data?: unknown) {
    MIX_PANEL.streamTrack?.track(event, data as Dict);
  }
}
